import type { CategoriesApi } from "@/v2/api/metadata/categories";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { createFeedConfigTab } from "./tabs/feed-config";
import { createFeedMappingTab } from "./tabs/feed-mapping";
import { limitsTab } from "./tabs/limits";
import { createLiveTab } from "./tabs/live";
import { createMainTab } from "./tabs/main";
import { createPrematchTab } from "./tabs/prematch";
import { createTranslationsTab } from "./tabs/translations";

export function createEditDialog(options: {
  ctx: BackofficeContext;
  categoriesApi: CategoriesApi;
}): DialogConfig {
  const { ctx, categoriesApi } = options;

  return {
    id: "edit-category",
    title: "Edit category",
    layout: {
      type: "popover",
    },
    api: {
      initialValues: async (row) => {
        const response = await categoriesApi.getSingle(row.id);
        const data = readApiData(response);
        return (data && typeof data === "object" && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >;
      },
      submit: async () => {},
    },
    structure: {
      type: "tabbed",
      savePerTab: true,
      tabs: [
        createMainTab(categoriesApi),
        createPrematchTab(categoriesApi),
        createLiveTab(categoriesApi),
        createTranslationsTab({ ctx, categoriesApi }),
        createFeedMappingTab(categoriesApi),
        createFeedConfigTab(categoriesApi),
        limitsTab,
      ],
    },
  };
}
